import { useEffect, useState } from "react";
import { Formik, ErrorMessage } from "formik";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
import * as categoryService from "../../../services/sub-categories.services";
import Breadcrums from "../../../common/breadcrumbs";
import { SWAL_SETTINGS } from "../../../../../utils/Constants";
import { globalLoader, handleServerValidations } from "../../../../../utils/commonfunction";
import * as Yup from "yup";
import { Loader } from "rsuite";
import { useTranslation } from "react-i18next";

const SubCategoriesAdd = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [submitted, setSubmitted] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [allCategories, setAllCategories] = useState([]);
  const [initialValues, setInitialValues] = useState({
    title: "",
    description: "",
    category: "",
  });

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: t("sidebar_link_sub_categories"), url: "/admin/manage-categories/sub-categories/list/1" },
    { title: t("link_add"), url: "" },
  ];

  useEffect(() => {
    categoryService
      .all()
      .then((data) => {
        console.log(data.data);
        console.log(data.data.list);
        setAllCategories(data && data.data && data.data.list ? data.data.list : []);
      })
      .catch((error) => {
        console.log("error ====> ", error);
      });
  }, []);

  useEffect(() => {
    setInitialValues({
      title: state && state?.title ? state.title : "",
      description: state && state?.link ? state.link : "",
      category: state && state?.category ? state.category : "",
      files: "",
    });
    setDataLoaded(true);
  }, []);

  const validationSchema = Yup.object().shape({
    title: Yup.string()
      .trim()
      .required(t("label_title_error"))
      .max(50, t("max_length_label"))
      .test("no-spaces", t("label_title_error"), (value) => value && value.trim()),
    category: Yup.string().required("Sub category is required"),
    description: Yup.string()
      .required(t("label_richtext_error"))
      .test("no-spaces", t("label_richtext_error"), (value) => value && value.trim()),
  });

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {dataLoaded ? (
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validateOnBlur={false}
          validationSchema={validationSchema}
          onSubmit={async (values, { setSubmitting, resetForm, setFieldError }) => {
            globalLoader(true);
            setSubmitted(true);

            try {
              let formData = new FormData();
              formData.append("title", values.title.trim());
              formData.append("description", values.description.trim());
              formData.append("category", values.category.trim());

              const response = await categoryService.Add(formData);
              console.log("response ====> ", response);

              if (response.success) {
                Swal.fire({
                  icon: "success",
                  text: "Sub category added successfully",
                  ...SWAL_SETTINGS,
                });
                globalLoader(false);
                setTimeout(() => {
                  resetForm({ values: "" });
                  navigate(`/admin/manage-categories/sub-categories/list/1`);
                }, 2000);
              } else {
                Swal.fire({
                  icon: "error",
                  text: handleServerValidations(response),
                  ...SWAL_SETTINGS,
                });
                globalLoader(false);
                setSubmitted(false);
              }
            } catch (error) {
              console.log("error ====> ", error);
              globalLoader(false);
              setSubmitted(false);
            } finally {
              setSubmitting(false);
            }
          }}>
          {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, setFieldTouched, isSubmitting }) => (
            <form onSubmit={handleSubmit}>
              <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                  <div className="card custom-card">
                    <div className="card-body">
                      <div>
                        <h6 className="main-content-label mb-3">
                          {t("link_add")} {t("sidebar_link_sub_categories")}
                        </h6>
                      </div>
                      <div className="row row-sm">
                        <div className="col-md-6 text-center form-group">
                          <label htmlFor="title" className="text-left d-flex">
                            {t("Title")}: <span className="requirestar">*</span>{" "}
                          </label>
                          <input name="title" id="title" type="text" onChange={handleChange} onBlur={handleBlur} value={values.title} className={`form-control ${errors.title && touched.title ? "is-invalid" : ""}`} />
                          <span className="text-danger d-flex text-left">
                            <ErrorMessage name={"title"} />
                          </span>
                        </div>

                        <div className="col-md-6 text-center form-group">
                          <label htmlFor="category" className="text-left d-flex">
                            {t("label_menu_of_the_select_category")}:<span className="requirestar">*</span>{" "}
                          </label>
                          <div className="select-down-arrow">
                            <select name="category" id="category" onChange={handleChange} onBlur={handleBlur} value={values.category} className={`form-control ${errors.category && touched.category ? "is-invalid" : ""}`} disabled={allCategories.length === 0}>
                              <option value="">{t("input_select_text")}</option>
                              {allCategories.map((category, i) => {
                                console.log(category);
                                return (
                                  <option key={category._id} value={category._id}>
                                    {t(`${category.title}`)}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                          <span className="text-danger d-flex text-left">
                            <ErrorMessage name="category" />
                          </span>
                        </div>

                        <div className="col-md-12 text-center form-group">
                          <label htmlFor="description" className="text-left d-flex">
                            {t("label_description")}:<span className="requirestar">*</span>
                          </label>
                          <textarea name="description" id="description" type="text" onChange={handleChange} onBlur={handleBlur} value={values.description} className={`form-control ${errors.description && touched.description ? "is-invalid" : ""}`} cols={4} rows={4} />
                          <span className="text-danger d-flex text-left">
                            <ErrorMessage name="description" />
                          </span>
                        </div>
                        <div className="">
                          <button className="btn btn-main-primary signbtn mr-2" type="submit" disabled={isSubmitting || submitted}>
                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                            {t("btn_submit")}
                          </button>
                          <button className="btn ripple btn-secondary" type="button" disabled={isSubmitting || submitted} onClick={() => navigate(-1)}>
                            <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                            {t("btn_cancel")}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default SubCategoriesAdd;
